import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/position/list",
    name: "UserPositionOverview",
    component: () => import("@/views/userposition/UserPositionOverview"),
    meta: {
      title: "nav.userposition.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_USER_POSITION_GENERAL],
    },
  },
  {
    path: "/position/create",
    name: "UserPositionCreate",
    component: () => import("@/views/userposition/UserPositionCreate"),
    meta: {
      title: "userposition.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_USER_POSITION_GENERAL],
    },
  },
  {
    path: "/position/:userPositionId",
    name: "UserPositionDetail",
    props: true,
    component: () => import("@/views/userposition/UserPositionDetail"),
    meta: {
      title: "nav.userposition.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_USER_POSITION_GENERAL],
    },
  },
]
